
// MediaSection.js
import React from 'react';
import { BadgeCheck, Globe, ShieldCheck } from 'lucide-react';

const MediaSection = () => {
  return (
    <section className="bg-white">
      <div className="mx-3 md:mx-10 lg:mx-16 py-10 md:py-12">
        <div className="rounded-2xl bg-gray-50 border border-gray-100 px-6 md:px-10 py-8 md:py-10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div>
              <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">
                Trusted by learners across Africa &amp; beyond
              </h2>
              <p className="mt-2 text-sm md:text-base text-acGray font-inter max-w-2xl">
                Curated listings with clear outcomes — courses are hosted and sold via secure third-party platforms.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 w-full md:w-auto">
              <div className="flex items-center gap-3 rounded-xl bg-white border border-gray-100 px-4 py-3">
                <span className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center">
                  <BadgeCheck className="text-blue-600" size={18} />
                </span>
                <div>
                  <div className="text-sm font-semibold text-acBlack font-inter">Verified picks</div>
                  <div className="text-xs text-acGray font-inter">Reviewed before listing</div>
                </div>
              </div>

              <div className="flex items-center gap-3 rounded-xl bg-white border border-gray-100 px-4 py-3">
                <span className="w-10 h-10 rounded-full bg-purple-50 flex items-center justify-center">
                  <Globe className="text-purple-600" size={18} />
                </span>
                <div>
                  <div className="text-sm font-semibold text-acBlack font-inter">Africa-first</div>
                  <div className="text-xs text-acGray font-inter">Built for local goals</div>
                </div>
              </div>

              <div className="flex items-center gap-3 rounded-xl bg-white border border-gray-100 px-4 py-3">
                <span className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center">
                  <ShieldCheck className="text-emerald-600" size={18} />
                </span>
                <div>
                  <div className="text-sm font-semibold text-acBlack font-inter">Secure checkout</div>
                  <div className="text-xs text-acGray font-inter">Trusted platforms</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaSection;
